<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-if="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Ordem</th>
                <th>Título Menu</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td  class="col-width-char30 center">{{ Funcoes.formatInteger(obj.ordem) }}</td>
                    <td>{{ obj.titulo }}</td>
            </tr></tbody>
        </table></div>

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <div class="form-edit-page">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption" for="titulo">Título</label>
                    <input type="text" v-model="objEdicao.titulo" id="titulo" maxlength="100" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption" for="ordem">Ordem Menu</label>
                    <input type="text" class="input-right" v-model="objEdicao.ordem" id="ordem" v-number maxlength="3" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Ícone do menu</label>

                    <div class="icon-card-row">
                        <div
                            v-for="icon in lsIconesMenu"
                            :key="icon.nome"
                            class="icon-card"
                            :class="{ selected: objEdicao.icone === icon.nome }"
                            @click="selecionarIcone(icon.nome)"
                        >
                            <img :src="icon.src" :alt="icon.nome" class="icon-card-img" />
                        </div>
                    </div>
                </div>
            </div>


            <div class="row-end">
                <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
                <button type="button" class="btn-cancel" @click="modoEdicao=false">Cancelar</button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport.js';
import { criarEpMenuDoc } from '@/models/epMenuDoc';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { iconRegistry } from '@/config/menuIconRegistry';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close']);

const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const objEdicao = ref(criarEpMenuDoc());

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const lsIconesMenu = [
    { nome: 'workflow1', src: iconRegistry.workflow1 },
    { nome: 'workflow2', src: iconRegistry.workflow2 },
    { nome: 'workflow3', src: iconRegistry.workflow3 },
    { nome: 'workflow4', src: iconRegistry.workflow4 },
    { nome: 'workflow5', src: iconRegistry.workflow5 },
];


function closeForm() {emit('close');}


function editarCadastro(obj) {
    setEdicao(obj.id);
}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/epmenuproc', {
            idep: globalStore.idep,
            nmpesquisar: nmPesquisa.value,
        });
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value = false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        const response  = await Api.genericPut('/cad/epmenu_proc', objEdicao.value);
        if (response.bolok === 1){
            await lerDados();
            modoEdicao.value = false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


function selecionarIcone(nome) {
    objEdicao.value.icone = nome;
}


async function setEdicao(idEdicao) {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (idEdicao > 0) {
            const req = await Api.getCadastroById('epmenu_proc', idEdicao);
            Object.assign(objEdicao.value, req[0]);
        }else{
            objEdicao.value = criarEpMenuDoc();
            objEdicao.value.idep = globalStore.idep;
        }
        objEdicao.value.idlogin = globalStore.idlogin;
        modoEdicao.value = true;
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value=false;}
}


function novoCadastro() {
    setEdicao(0);
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function validarDados(){
    let r = Validar.texto(objEdicao.value.titulo, 'Informe título do menu');
    if (!r.ok) return r.msg;
    return null;
}


onMounted(lerDados);
</script>

<style scoped>
.icon-card-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;
}

.icon-card {
    width: 110px;
    min-height: 90px;
    padding: 10px;
    border: 1px solid #d7d7d7;
    border-radius: 8px;
    background: #f8f9fa;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;

    font-size: 13px;
    text-align: center;
}

.icon-card:hover {
    background: #eef3f8;
    border-color: #9fb6cc;
}

.icon-card.selected {
    border: 2px solid #2f80ed;
    background: #eaf3ff;
}

.icon-card-img {
    width: 32px;
    height: 32px;
    object-fit: contain;
}
</style>